export default __webpack_public_path__ + "static/media/553.a39b0d42.png";